export const COMPANY_SCALES = [
  '개인(1인기업)',
  '2~4명',
  '5~9명',
  '10~19명',
  '20~49명',
  '50~99명',
  '100~299명',
  '300~499명',
  '500~999명',
  '1,000명 이상',
];
export const DEPARTMENTS = [
  '소속 없음',
  '개발',
  '경영지원',
  '고객만족',
  '구매',
  '기획',
  '디자인',
  '마케팅',
  '법무',
  '생산',
  '연구',
  '영업',
  '운영',
  '인사',
  '총무',
  '홍보',
  '회계',
  '총괄',
  '기타',
];
export const COMPANY_CATEGORIES = [
  '소속 없음',
  '건설',
  '광고',
  '교육기관',
  '교육 서비스',
  '국가 기관',
  '금융 및 보험',
  '도매',
  '렌탈',
  '무역',
  '법률 서비스',
  '부동산',
  '뷰티',
  '세무 및 회계',
  '소매',
  '숙박',
  '스포츠 및 엔터테인먼트',
  '에이전시',
  '여행',
  '영상',
  '예술',
  '운수',
  '의료',
  '전자상거래',
  '제조',
  '출판 및 인쇄',
  '컨설팅',
  '패션',
  '프랜차이즈',
  '핀테크 서비스',
  '헬스케어',
  '협회 및 단체',
  'IT',
  'O2O 서비스',
  '기타',
];

export const JOB_ROLES = [
  { title: '계약 업무를 맡고 있어요.', value: '계약자' },
  { title: '서비스/비품 구매를 담당하고 있어요.', value: '구매자' },
  { title: '최종적으로 서비스 이용을 승인해요.', value: '승인자' },
  { title: '해당 사항 없어요.', value: '기타' },
];

export const EXPECTED_USAGES = [
  { title: '60건 이하', value: '60 이하' },
  { title: '60~360건', value: '60~360' },
  { title: '360~1,000건', value: '360~1,000' },
  { title: '1,000~5,000건', value: '1,000~5,000' },
  { title: '5,000건 이상', value: '5,000 이상' },
  { title: '계약 없음', value: '계약 없음' },
];
export const EXPECTED_START_TIMES = [
  '가능한 빠르게',
  '3개월 이내로',
  '12개월 이내로',
  '정해지지 않았으나 검토 중',
  '아직 도입 고려하지 않음',
  '이미 유료 요금제 이용 중',
];

export const PURPOSES = [
  '계약 (작성~체결)',
  '계약 문서에 서명',
  '서명한 계약 문서 확인',
  'CRM/ERP 그룹웨어 연동',
  '사인/도장 제작',
  '기타',
];
